export const parseMaterialFromText = (text) => {
  const lines = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  let name = "";
  let description = "";
  let quality = "";
  let rarity = "";

  for (const line of lines) {
    if (line.toLowerCase().startsWith("material name:")) {
      name = line.split(":")[1]?.trim() || "";
    } else if (line.toLowerCase().startsWith("short description:")) {
      description = line.split(":")[1]?.trim() || "";
    } else if (line.toLowerCase().startsWith("quality:")) {
      quality = line.split(":")[1]?.trim() || "";
    } else if (line.toLowerCase().startsWith("rarity:")) {
      rarity = line.split(":")[1]?.trim() || "";
    }
  }

  return { name, description, quality, rarity };
};
